import { ParseJson } from '../Functions'
import { encrypt, decrypt } from '../Encrypt'

const EncryptKey = '09ac581'
// 데이터 필요할 듯

// Key Value based, for low capacity
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace LocalDocument {
  // 플랫폼 지정
  export const get = async <T>(key: string): Promise<T | undefined> => {
    return new Promise(resolve => {
      const getItem = localStorage.getItem(key)
      if (getItem) {
        return resolve(ParseJson(decrypt(getItem, EncryptKey)) as T)
      } else {
        return resolve(undefined)
      }
    })
  }

  export const set = async <T>(key: string, value: T): Promise<void> => {
    const input = (value == undefined ? '' : value) as string | T
    const isObject = typeof input == 'object'
    const insertValue = isObject ? JSON.stringify(input) : input

    return new Promise(resolve => {
      return resolve(localStorage.setItem(key, encrypt(`${insertValue}`, EncryptKey)))
    })
  }

  export const del = (key: string): void => {
    localStorage.removeItem(key)
  }

  export const getKeys: () => Promise<string[]> = async () => {
    const output = <string[]>[]
    return new Promise(resolve => {
      for (let i = 0; i < localStorage.length; i++) {
        const _key = localStorage.key(i)
        if (!_key) continue
        output.push(_key)
      }
      return resolve(output)
    })
  }

  export const clear = async (): Promise<void> => {
    return new Promise(() => {
      return localStorage.clear()
    })
  }
}
